import React, { PropTypes } from 'react';
import AccountingCodeLine from './AccountingCodeLine';
import { Header, Segment, Table } from 'semantic-ui-react';
import AccountingCodeModal from './AccountingCodeModal';

export class AccountingCodesDetail extends React.Component {
  static propTypes = {
    lines: PropTypes.array.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      lines: props.lines,
      modalOpened: false,
      deletedIds: [],
      current: -1,
    };

    this.onNewLineClick = this.onNewLineClick.bind(this);
    this.onDeleteLine = this.onDeleteLine.bind(this);
  }

  onDeleteLine(index) {
    return evt => {
      const toDelete = this.state.lines[index];
      if (toDelete.id) {
        this.state.deletedIds.splice(0, 0, toDelete.id);
      }

      this.state.lines.splice(index, 1);
      this.setState({
        lines: this.state.lines,
      });
    };
  }

  onNewLineClick() {
    this.setState({
      current: this.state.lines.length,
      modalOpened: true,
    });
  }

  onModalClose() {}

  onModalSave(index) {
    return line => {
      const newLines = this.state.lines;
      newLines[index] = line;

      this.setState({
        modalOpened: false,
        lines: newLines,
      });

      if (this.props.onChange) {
        this.props.onChange(newLines);
      }
    };
  }

  render() {
    const { lines, modalOpened, current } = this.state;
    let currentLine = lines[current];
    let newLine = false;
    if (!currentLine) {
      currentLine = { accounting_code: '' };
      newLine = true;
    }
    return (
      <Segment>
        <Header size="tiny">Code client comptable</Header>
        <Table striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width={2} />
              <Table.HeaderCell width={12} />
              <Table.HeaderCell textAlign="right" width={2}>
                <a
                  className="ui right floated labeled icon button"
                  onClick={this.onNewLineClick}
                >
                  <i className="icon add" />
                  Ajouter
                </a>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {lines &&
              lines
                //.sort(sortLines)
                .map(l => (
                  <AccountingCodeLine
                    key={lines.indexOf(l)}
                    index={lines.indexOf(l)}
                    data={l}
                    onDelete={this.onDeleteLine(lines.indexOf(l))}
                  />
                ))}
          </Table.Body>
          <AccountingCodeModal
            visible={modalOpened}
            index={current}
            line={currentLine}
            newLine={newLine}
            onClose={this.onModalClose}
            onSave={this.onModalSave(current)}
          />
        </Table>
      </Segment>
    );
  }
}

AccountingCodesDetail.propTypes = {
  lines: PropTypes.array.isRequired,
};

export default AccountingCodesDetail;



// WEBPACK FOOTER //
// ./src/modules/saas/customers/components/AccountingCodesDetail.js